import { getPanelAccessToken } from './apiAuthProvider';

const getApiUrl = () => {
  const base = process.env.REACT_APP_API_URL ?? 'http://localhost:3001';
  return base.replace(/\/$/, '');
};

const EMPTY_SUMMARY = {
  total: 0,
  byType: { venue: 0, organisationCompany: 0, salesAgent: 0 },
  items: [],
};

export const fetchPendingApplicationsSummary = async () => {
  const token = getPanelAccessToken();
  if (!token) return EMPTY_SUMMARY;

  const res = await fetch(
    `${getApiUrl()}/eventCreationApplications/pending/summary`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );

  if (!res.ok) {
    if (res.status === 403) return EMPTY_SUMMARY;
    throw new Error(`Pending applications summary failed (${res.status})`);
  }

  return res.json();
};

export const APPLICATION_LIST_PATHS = {
  venue: '/venues?tab=applications',
  organisationCompany: '/organisationCompanies?tab=applications',
  salesAgent: '/saleAgents?tab=applications',
};

export const APPLICATION_TYPE_LABELS = {
  venue: 'Mekan',
  organisationCompany: 'Organizatör',
  salesAgent: 'Satış Ortağı',
  affiliate: 'Satış Ortağı',
};
